export default {"src":"/_next/static/media/tap.3795490e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};